var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ButtonAFY, GridAFY, ModalComponentAFY, sizes, variants } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
export var Modal = function (props) {
    return (_jsx(_Fragment, { children: _jsxs(ModalComponentAFY, __assign({ openModal: props.openModal, onClose: function () {
                props.close();
            }, border: 0, backgroundColor: themeCore.colors.background, modalHeight: "500", modalWidth: 1000, minWidthModal: "80%", padding: 10 }, { children: [_jsxs("div", __assign({ className: "centerTitle" }, { children: [" ", props.title, " "] })), _jsx("div", __assign({ className: "box" }, { children: _jsx(GridAFY, { columns: props.columns, height: "371px", onClick: function noRefCheck() { }, pageSize: 5, rows: props.rows, width: "100%" }) })), _jsx("div", __assign({ className: "divContainerButtons" }, { children: _jsx(ButtonAFY, { variant: variants.outlined, label: "Cerrar", size: sizes.large, onClick: props.close }) }))] })) }));
};
